import Proxy from "./Proxy"

class ProductProxy extends Proxy {
  constructor(parameters = {}) {
    super("contract-types", parameters)
  }
}

export default ProductProxy
